import {addFilter} from "@wordpress/hooks";

import mapPin from "./map-pin.svg?string";

addFilter("plaudit.query-loop.google-maps-integration.marker-handler-config", "plaudit-site/extensions", (config: any) => {
	config.iconMap['default'] = new DOMParser().parseFromString(mapPin, 'image/svg+xml').documentElement;
	return config;
});
